import { FormSelectOption } from '@app/shared/form/inputs/form-select.component';

const questions: Array<FormSelectOption> = [
  {
    option: 'fav_teacher',
    value: 'What was the last name of your favourite teacher?'
  },
  {
    option: 'pet_name',
    value: 'What was the name of your first pet?'
  },
  {
    option: 'mother_nname',
    value: 'What was your mother\'s maiden name?'
  },
  {
    option: 'time_born',
    value: 'At what time were you born at? (hh:mm)'
  },
  {
    option: 'first_fly',
    value: 'Where did you fly the first time you flew a plane?'
  },
  {
    option: 'spouse_loc',
    value: 'Where did you meet your spouse?'
  },
  {
    option: 'mother_name',
    value: 'What\'s your mother name?'
  },
];

export default questions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/data/security-question.data.ts